import { GetProductsRequest } from './product.request';

export class AggregatorRequest {
  vin: string;
  saleDate: string;
  odometer: number;
  inServiceDate: string;
  financeType: string;
  isAfterSale: string;
  vehiclePurchaseDate: string;
  programName: string;
  vehicleMake: string;
  vehicleYear: number;
  vehicleModel: string;
  vehicleTrim: string;
  vehicleCondition: string;
  groupCode: string;
  financeAmount: number;
  vehicleCost: number;
  vehicleMSRP: number;
  customerState: string;
  lienholderName: string;
  languageCode: string;

  constructor(request: GetProductsRequest) {
    this.vin = request.vin;
    this.saleDate = request.saleDate;
    this.odometer = +request.odometer;
    this.inServiceDate = request.inServiceDate;
    this.financeType = request.financeType;
    this.isAfterSale = request.isAfterSale;
    this.vehiclePurchaseDate = request.vehiclePurchaseDate;
    this.programName = request.programName;
    this.vehicleMake = request.vehicleMake;
    this.vehicleYear = +request.vehicleYear;
    this.vehicleModel = request.vehicleModel;
    this.vehicleTrim = request.vehicleTrim;
    this.vehicleCondition = request.vehicleCondition;
    this.financeAmount = +request.financeAmount;
    this.vehicleCost = +request.vehicleCost;
    this.vehicleMSRP = +request.msrp;
    this.customerState = request.customerState;
    this.lienholderName = request.lienholderName;
    this.languageCode = request.languageCode;

    this.groupCode = '';
  }
}
